import axios from '@/axios.js'
let token = localStorage.getItem('accessToken');
let entityURL = 'changedPrices'; // variant depending on entity URLs
let apiEndpoint = localStorage.getItem('apiEndpoint');

axios.defaults.baseURL = apiEndpoint;
axios.defaults.headers.common = { 'Authorization': `bearer ${token}` }

const state = {
    changedPrices: [],
}

const getters = {
    getChangedPrices: (state) => (state.changedPrices),
}

const actions = {
    async fetchChangedPrices({ commit }) {
        const response = await axios(`${entityURL}/list`)
        commit('SET_CHANGED_PRICES', response.data.object)
    },
}

const mutations = {
    SET_CHANGED_PRICES: (state, data) => (state.changedPrices = data)
}

export default { state, getters, actions, mutations }
